import { AnalysedProposalsCard } from "./variants/AnalysedProposals";
import { MonthlyTransactionCard } from "./variants/MonthlyTransactions";
import { NegatedReasonCard } from "./variants/NegatedReason";

export const ReportCard = {
  AnalysedProposals: AnalysedProposalsCard,
  NegatedReason: NegatedReasonCard,
  MonthlyTransactions: MonthlyTransactionCard
};
